















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ToggleSwitch from '@/components/ToggleSwitch.vue'
import { Getter } from 'vuex-class'
import { TipoVariable, Estacion } from '@/store/modules/estaciones/types'
import { GrupoTipoVariableApi } from '@/domain/entities/Api'
import { InfoView } from '@/store/modules/google-maps/types'

const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    ToggleSwitch
  }
})
export default class EstacionesControl extends Vue {
  @Getter('getGrupoTipoVariable', { namespace: 'estaciones' }) grupoTipoVariable!: GrupoTipoVariableApi[]
  @Getter('getTipoVariables', { namespace: 'estaciones' }) tipoVariable!: TipoVariable[]
  @Getter('getEstaciones', { namespace: 'estaciones' }) estaciones!: Estacion[]

  @Getter('infoView', { namespace: GOOGLE_MAPS_MODULE })
  private infoView!: InfoView

  private grupoTipoVariableSelected: string = ''
  private tipoVariableSelected: string = ''
  private estacionSelected: string = ''
  path: string = '/estaciones'

  get isSubmenuSelected () {
    return this.$route.path === this.path
  }

  async mounted () {
    const gtv = this.$router.currentRoute.query.grupotipovariable
    const tv = this.$router.currentRoute.query.tipovariable
    const estacion = this.$router.currentRoute.query.estacion
    this.grupoTipoVariableSelected = (gtv) ? gtv.toString() : ''
    await this.$nextTick()
    this.tipoVariableSelected = (tv) ? tv.toString() : ''
    await this.$nextTick()
    this.estacionSelected = (estacion) ? estacion.toString() : ''
  }

  @Watch('grupoTipoVariableSelected')
  async grupoTipoVariableSelectedChanged (val: string, oldVal: string) {
    try {
      const grupotipovariable = (val !== '') ? val : undefined
      const oldgrupotipovariable = (oldVal !== '') ? oldVal : undefined
      const queryGTV = this.$router.currentRoute.query.grupotipovariable
      if (Number(queryGTV) !== Number(grupotipovariable || 0)) {
        await this.$router.push({
          query: Object.assign({}, {
            grupotipovariable
          })
        })
      }
      if ((grupotipovariable !== oldgrupotipovariable) || typeof grupotipovariable === 'undefined') {
        this.tipoVariableSelected = ''
        this.estacionSelected = ''
      }
    } catch (e) {
      console.error(e)
    }
  }

  @Watch('tipoVariableSelected')
  async tipoVariableSelectedChanged (val: string, oldVal: string) {
    const tipovariable = (val !== '') ? val : undefined
    const oldtipovariable = (oldVal !== '') ? oldVal : undefined
    const { tipovariable: queryTipoVariable } = this.$router.currentRoute.query
    if (queryTipoVariable !== tipovariable) {
      await this.$router.push({
        query: Object.assign({}, this.$route.query, {
          tipovariable
        })
      })
    }
    if ((tipovariable !== oldtipovariable) || typeof tipovariable === 'undefined') {
      this.estacionSelected = ''
    }
  }

  @Watch('estacionSelected')
  async estacionSelectedChanged (val: string, oldVal: string) {
    try {
      if (Number(val) !== Number(this.$route.query.estacion)) {
        await this.$router.push({
          query: Object.assign({}, this.$route.query, {
            estacion: (val !== '') ? val : undefined
          })
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  @Watch('infoView.status')
  async infoViewStatusChanged (val: any) {
    try {
      if (val.active === true && val.selectedMarker !== '' && val.selectedMarker !== this.estacionSelected) {
        this.estacionSelected = val.selectedMarker
      }
    } catch (e) {
      console.error(e)
    }
  }
}
